import { Navigate } from 'react-router';
interface PublicRouteProps {
  children: React.ReactNode;
}
const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true; 
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1])); 
    return payload.exp < Date.now() / 1000; 
  } catch {
    return true; 
  }
};

export default function PublicRoute({ children }: PublicRouteProps) {
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token && !isTokenExpired(token);
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>; 
}